export const ANTI_FRAUD = {
	DEVICE_BLACK_BOX: "EREDAV",
	PLATFORM: "WEB",
	APP_VERSION: "1.0",
	TRANSACTION_MARKET: "KH",
	USER_MARKET: "KH",
	USER_COUNTRY_CODE: "KH",
}



// WEBPACK FOOTER //
// ./src/constants/antiFraud.js